module.exports = __webpack_public_path__ + "static/media/Avenir-Light.9f5584ac.otf";